import React from "react";
import PropTypes from "prop-types";

function Wallet(props) {
  const { size, ...rest } = props;

  return (
    <svg {...rest} width={size} height={size} fill="white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29.51 27.96">
      <path
        d="M28,15.24l.5.1a1.82,1.82,0,0,1,1.27,1.74c0,1.44,0,2.89,0,4.34A1.86,1.86,0,0,1,28,23.36v.19c0,.6,0,1.2,0,1.8a3.81,3.81,0,0,1-1.49,2.73,4,4,0,0,1-2.62.9H4.33a4.06,4.06,0,0,1-4.08-4.1v-15A3.74,3.74,0,0,1,3.88,6.18c1.15,0,2.3,0,3.46,0,.14,0,.19,0,.24-.18A6.89,6.89,0,0,1,13,1.16a7,7,0,0,1,7.29,3.18A6.52,6.52,0,0,1,21,6a.19.19,0,0,0,.22.16H23A2.76,2.76,0,0,1,25.85,9c0,.35,0,.7,0,1.05a.23.23,0,0,0,.13.23,3.9,3.9,0,0,1,1.95,2.92A15.63,15.63,0,0,1,28,14.91ZM2.29,9.43h0a6.88,6.88,0,0,0-.1.9c0,4.87,0,9.73,0,14.6a2,2,0,0,0,.27,1,2.1,2.1,0,0,0,1.9,1.11H23.94a2.14,2.14,0,0,0,2.11-1.9c.05-.58,0-1.18,0-1.77,0,0,0,0,0-.05H23.34A4,4,0,0,1,23,15.28c.91,0,1.82,0,2.73,0h.3a.81.81,0,0,0,0-.09c0-.49,0-1,0-1.46a2.13,2.13,0,0,0-2.19-2.06H12.75c-2.36,0-4.72,0-7.07,0a3.61,3.61,0,0,1-2.83-1.39C2.64,10,2.48,9.7,2.29,9.43Zm13.9.3h2.89a.18.18,0,0,0,.13-.11,8.71,8.71,0,0,0,.22-1.11,4.94,4.94,0,0,0-2-4.51,4.88,4.88,0,0,0-5.52-.47A5,5,0,0,0,9.17,7.77a4.83,4.83,0,0,0,.27,2h3c0-.4.18-.52.58-.53h.41a.45.45,0,0,1,.45.42s.05.12.08.12h.84a3.52,3.52,0,0,1,0-.46.52.52,0,0,0-.36-.58c-.4-.18-.81-.35-1.2-.56A1.4,1.4,0,0,1,12.44,7c0-.16,0-.33,0-.49a1.33,1.33,0,0,1,.94-1.38.29.29,0,0,0,.23-.35A.41.41,0,0,1,14,4.32a5.61,5.61,0,0,1,.58,0,.43.43,0,0,1,.42.44V5a1.46,1.46,0,0,1,1.14,1.59c0,.2-.08.3-.28.31S15.31,7,15,7a.28.28,0,0,1-.29-.31V6.5c0-.25-.16-.36-.46-.35s-.42.12-.43.37a1.71,1.71,0,0,0,0,.32.94.94,0,0,0,.15.32,1,1,0,0,0,.29.18c.39.18.79.33,1.16.53a1.3,1.3,0,0,1,.74,1.24Zm11.65,7.44-.11,0c-1.47,0-2.94,0-4.41,0a2.15,2.15,0,1,0,0,4.29c1.46,0,2.92,0,4.39,0h.14ZM7.23,8.09H3.91a.22.22,0,0,0,0,.09A1.86,1.86,0,0,0,5.6,9.73c.61,0,1.23,0,1.83,0Zm14,1.65h2.76a7.33,7.33,0,0,0,0-.94.83.83,0,0,0-.82-.72H21.39Z"
        transform="translate(-0.25 -1.02)"
      />
      <path d="M22.28,19.32a1.07,1.07,0,0,1,2.14,0,1.07,1.07,0,0,1-2.14,0Z" transform="translate(-0.25 -1.02)" />
    </svg>
  );
}

export default Wallet;

Wallet.propTypes = {
  stroke: PropTypes.string.isRequired,
  fill: PropTypes.string.isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

Wallet.defaultProps = {
  stroke: "currentColor",
  strokeWidth: 0,
  fill: "white",
  size: "1rem",
};
